import { render, staticRenderFns } from "./PreferenceSetting.vue?vue&type=template&id=741e9945&scoped=true"
import script from "./PreferenceSetting.vue?vue&type=script&lang=js"
export * from "./PreferenceSetting.vue?vue&type=script&lang=js"
import style1 from "./PreferenceSetting.vue?vue&type=style&index=1&id=741e9945&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741e9945",
  null
  
)

export default component.exports